<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter-title"><span><a href="#/toc#toc-map"></a></span></h1><a id="p6"></a>
<p class="image"><span><img alt="image" height="460" src="images/Art_P6.jpg" width="493"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?e0265e8c